<template>
  <div>
    <b-card title="">
      <custom-g-table
        v-if="displayTable"
        ref="custom-table"
        :displayLoading="tableLoading"
        :fields="fields"
        :items="data"
        :totalRows="totalRows"
        :limit="limit"
        :hasResendButton="true"
        :hasOpenTemplateButton="true"
        @changePage="onChangePage"
        @onSortChange="onSortChange"
        @onColumnFilter="onFilter"
        @onResend="onResend"
        @openTemplate="openTemplate"
      />
    </b-card>

    <b-modal
      ref="template-email-modal"
      id="template-email-modal"
      modal-class="modal-primary"
      title="Template email"
      ok-title="Adicionar"
      centered
      no-close-on-backdrop
    >
      <div class="d-block">
        <iframe :srcdoc="currentTemplate" frameborder="0" width="100%" height="100%"></iframe>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BCard } from "bootstrap-vue";
import CustomGTable from "@/views/custom/table/CustomGTable.vue";
import sendmailService from "@/providers/sendmailService";
import dropdownService from "@/providers/dropdownService";
import { setRouteQuery, buildParamsRouteQuery } from "@/helpers/route-query-helper";
import messagesNotifyHelper from "@/helpers/messages-notify-helper";
import messageDialogHelper from "@/helpers/message-dialog-helper";
import { onlyLatestRequest } from "@/helpers/latest-request-helper";

export default {
  props: {
    urlQuery: Object
  },
  components: {
    BCard,
    CustomGTable,
    // CustomFilter,
  },
  data() {
    return {
      displayTable: false,
      sortField: {},
      data: [],
      totalRows: 0,
      limit: 50,
      page: 1,
      filter: {},
      tableLoading: true,
      fields: [
        { field: "action_buttons", label: "Ações", sortable: false },
        {
          field: "dt_create",
          label: "Criação",
          type: "custom_date",
          sortable: true,
          filterOptions: {
            filterValue: '',
            enabled: true,
            placeholder: "Pesquisar por data",
            trigger: "enter",
          },
        },
        {
          field: "to",
          label: "Para",
          sortable: false,
          filterOptions: {
            filterValue: '',
            enabled: true,
            placeholder: "Pesquisar por Destinatário",
            trigger: "enter",
          },
        },
        {
          field: "toMany",
          label: "Para",
          sortable: false
        },
        {
          field: "subject",
          label: "Assunto",
          sortable: false,
          filterOptions: {
            filterValue: '',
            enabled: true,
            placeholder: "Pesquisar por Assunto",
            trigger: "enter",
          },
        },
        {
          field: "emailProvider",
          label: "Provedor",
          sortable: false,
        },
        { field: "sent", label: "Enviado", type: "boolean", sortable: false, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por Enviado', filterDropdownItems: [{value: true, text: 'Sim'}, {value: false, text: 'Não'}] } },
        {
          field: "dt_sent",
          label: "Data de Envio",
          type: "custom_date",
          sortable: true,
          filterOptions: {
            filterValue: '',
            enabled: true,
            placeholder: "Pesquisar por data envio",
            trigger: "enter",
          },
        },
        {
          field: "dt_update",
          label: "Alteração",
          type: "custom_date",
          sortable: false,
        },
        {
          field: "errorMessage",
          label: "Mensagem de erro",
          sortable: false,
          filterOptions: {
            filterValue: '',
            enabled: true,
            placeholder: "Pesquisar por Mensagem erro",
            trigger: "enter",
          },
        },
        {
          field: "html",
          label: "HTML",
          sortable: false,
        },
      ],
      origins: [],
      currentTemplate: ''
    };
  },
  mounted() {
    this.$store.dispatch("admin/updatePageTitle", "E-mail");
    this.loadData();
  },
  computed: {
    searchParams() {
      const params = buildParamsRouteQuery(this.$route.query);
      params.append("page", this.page);
      params.append("limit", this.limit);

      if (this.sortField.field) {
        params.append(`sort_${this.sortField.field}`, this.sortField.type);
      }

      return params;
    },
  },
  methods: {
    openTemplate(val) {
      this.currentTemplate = val.html;
      this.$refs["template-email-modal"].show();
    },
    onResend(data) {
      messageDialogHelper.displayConfirmMessage(
        "E-mail",
        "Certeza que deseja forçar o envio deste e-mail agora?",
        () => {
          sendmailService
            .forceSend(data._id)
            .then(() => {
              messagesNotifyHelper.successNotify('Sucesso', 'E-mail enviado com sucesso.');
              this.loadData();
            })
            .catch((err) => {
              console.log(err);
              messagesNotifyHelper.errorNotify('Erro', err);
            });
        });
    },
    setInitialTableFilters() {
      Object.keys(this.urlQuery).forEach(item => {
        this.fields[this.fields.findIndex(val => val.field==item)].filterOptions.filterValue = this.urlQuery[item];
      });
      this.loadData();
    },
    reportData() {
      const params = this.searchParams;
      params.append("download", true);
      sendmailService
        .report(params)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");

          link.href = url;
          link.setAttribute("download", 'sendmail.xlsx');
          link.setAttribute("id", "link-download");

          document.body.appendChild(link);
          link.click();

          document.getElementById("link-download").remove();
        })
        .catch((err) => console.log(err));
    },
    onChangePage(page) {
      this.page = page;
      this.loadData();
    },
    onFilter(data) {
      // this.filter = data;
      // console.log("OnFilter: ", data);
      setRouteQuery(data, this.$route.query);
      this.loadData();
    },
    loadDataFilter() {
      Promise.all([
        dropdownService.getAuditlogAction(new URLSearchParams()),
        dropdownService.getAuditlogName(new URLSearchParams()),
      ])
        .then((res) => {
          this.fields[
            this.fields.findIndex((item) => item.field == "action")
          ].filterOptions.filterDropdownItems = res[0].map((item) => {
            return { value: item, text: item };
          });
          this.fields[
            this.fields.findIndex((item) => item.field == "name")
          ].filterOptions.filterDropdownItems = res[1].map((item) => {
            return { value: item, text: item };
          });
          this.setInitialTableFilters();
        })
        .catch((err) => console.log(err));
    },
    loadData() {
      this.data = [];
      this.tableLoading = true;
      // this.$refs['custom-table'].rows = [];
      // this.$refs['custom-table'].isLoading = true;
      onlyLatestRequest(this, 'loadData', sendmailService.getall(this.searchParams))
        .then((res) => {
          this.displayTable = true;
          this.data = res.data;
          this.totalRows = res.totalRows;
          this.tableLoading = false;
        })
        .catch((err) => {
          this.displayTable = true;
          console.log(err);
        });
    },
    onSortChange(params) {
      this.sortField = params;
      this.loadData();
    },
  },
};
</script>

<style>
</style>